import { render, staticRenderFns } from "./salInsuredList.vue?vue&type=template&id=1eebb678&scoped=true&"
import script from "./salInsuredList.vue?vue&type=script&lang=js&"
export * from "./salInsuredList.vue?vue&type=script&lang=js&"
import style0 from "./salInsuredList.vue?vue&type=style&index=0&id=1eebb678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebb678",
  null
  
)

export default component.exports